import HeaderBack from "@/components/fragments/HeaderBack";
import CustomerForm from "@/features/Customer/components/Form";
import { getStoredUserData } from "@/utils/getStoredUser";
import { useParams } from "react-router-dom";

export default function CustomerEdit() {
  const userData = getStoredUserData();
  const { id } = useParams<{ id: string }>();
  let email = userData?.email || "";
  return (
    <div className="md:w-[80vw] lg:w-[70vw] mx-auto h-screen">
      <HeaderBack text="Edit Customer" url={`/customer/${id}`} />
      <CustomerForm id={id} email={email} />
    </div>
  );
}
